import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexPlotOptions, ApexXAxis, ApexYAxis } from 'ng-apexcharts';
import { BehaviorSubject, forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CurrencyService } from 'src/app/services/currency.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { ReportSettingsService } from 'src/app/settings/report-settings/report-settings.service';
import { AppState } from 'src/app/store/app.state';
import DateUtils from 'src/app/utils/date';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[]
};
@Component({
  selector: 'app-new-invoice',
  templateUrl: './new-invoice.component.html',
  styleUrls: ['./new-invoice.component.css']
})

export class NewInvoiceComponent implements OnInit, OnDestroy {
  dataTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      { title: "Salesperson", key: "name" },
      { title: "Count", key: "count" },
      { title: `Amount`, key: "amount", transform: (f) => this.transformAmount(f) },
    ],
    rows: null,
    options: {
      debug: false, // change to true if you want to see datatable events
      noOfRowsToDisplay: 3, // change the amount of data you want to display at a particular time
      bulkActions: [],
      singleActions: [],
    }
  }
  dateUtil = new DateUtils;
  user;
  teamID;
  invoiceList;
  baseCurrency;
  result;
  private unsubscribe = new Subject();
  months = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 };
  loading = { invGraph: true, }
  invFilt = { filter: 'SALESPERSON', year: new Date().getFullYear() };
  unfilteredTableResult: any[]
  constructor(
    private invoiceServ: InvoiceService,
    private currencySrv: CurrencyService,
    private reportSetSrv: ReportSettingsService,
    store: Store<AppState>
  ) {
    this.currencySrv.org_currencies.subscribe((org_currencies) => {
      this.baseCurrency = org_currencies && org_currencies.base_currency ? org_currencies.base_currency : "";
      this.dataTable.heads[2].title = `Amount (${this.baseCurrency})`
    });
    store.select("userInfo").subscribe((info) => {
      this.user = info.user.id;
      this.teamID = info.user.teamID;
    });
  }

  transformAmount(amount) {
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(amount)
  }

  ngOnInit() {
    this.getNewInvoice();
  }
  private getQuery = (value) => {
    const { getTsByNum, getEndTimeStp } = this.dateUtil;
    const endDate = getEndTimeStp(new Date())
    return `range=${(JSON.stringify({ createdAt: { from: getTsByNum(value), to: endDate } }))}`
  }
  getQueryCur(value) {
    const { getTsByNum, getEndTimeStp } = this.dateUtil;
    const endDate = getEndTimeStp(new Date())
    const startDate = getTsByNum(value);
    return { startDate, endDate }
  }

  convertCurEqiToObj(datas: any[]) {
    const obj = {};
    datas.forEach(dat => obj[dat.itemId] = dat)
    return obj
  }

  getNewInvoice() {
    this.dataTable.rows = null;
    this.reportSetSrv.getReportConfig().subscribe(repSet => {
      const config = repSet ? repSet.newInvoiceDays : 0;
      this.invoiceServ.getInvoiceByFilter(this.getQuery(config)).subscribe(res => {
        const { payload } = res;
        let item = this.currencySrv.dataSourceInBase(payload);
        this.getTableData(item);
      })
    })
  }
  
  getTableData(invoice: any[]) {
    const salesPerInv = {};
    const salespersonNames = {};
    invoice.forEach(inv => {
      if (salesPerInv[inv.createdBy]) {
        let { count, amount } = salesPerInv[inv.createdBy];
        count = count + 1
        amount = amount + inv.totalCost;
        salesPerInv[inv.createdBy] = { count, amount };
      } else {
        salespersonNames[inv.createdBy] = inv.ownerName || 'Unspecified';
        salesPerInv[inv.createdBy] = { count: 1, amount: inv.totalCost }
      }
    });
    const result = [];
    Object.keys(salesPerInv).forEach(salesper => {
      const { count, amount } = salesPerInv[salesper];
      result.push({ name: salespersonNames[salesper], count, amount })
    });
    this.dataTable.rows = result;
    this.dataTable.dataChangedObs.next(true);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
